import * as React from "react";
import {Helmet} from "react-helmet";
import BreadcrumbsBlock from "../layouts/breadcrumbs-block/breadcrumbs-block";
import ServiceStatuteBlock from "../layouts/statute-block/service-statute-block";
import * as helmetData from "../constants/helmet-data";
import {PageType} from "../models/types";
import * as cacheBustingService from "../services/cache-busting-service";

interface RegulaminPageProps {}

interface RegulaminPageState {}

class RegulaminPage extends React.Component<RegulaminPageProps,RegulaminPageState> {

  componentDidMount() {
    cacheBustingService.handleCacheBusting(caches);
  }

  render() {
    return (
      <div>
        <Helmet {...helmetData.prepareHelmetData(PageType.RegulaminPage)}/>

        <BreadcrumbsBlock
          breadcrumbsElement={
            {
              elementName: "REGULAMIN",
              elementDescription: ""
            }
          }
        />
        <ServiceStatuteBlock/>
      </div>
    )
  }

}

export default RegulaminPage


// WEBPACK FOOTER //
// ./src/pages/regulamin.tsx